"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("../helpers");
const AuthClient_1 = __importDefault(require("./AuthClient"));
class AuthFactory {
    static getInstance(http, storage, subscriptions, bitloopsConfig) {
        if ((0, helpers_1.isBrowser)())
            return new AuthClient_1.default(subscriptions, storage, http, bitloopsConfig);
        // eslint-disable-next-line global-require
        const authServerPath = './AuthServer'; // Do not remove this (it's used in order to not evaluate the require below when it's compiled)
        const AuthServer = require(authServerPath).default; // TODO change it to use async import
        return new AuthServer(storage, http, bitloopsConfig);
    }
}
exports.default = AuthFactory;
//# sourceMappingURL=AuthFactory.js.map